window.googletag = window.googletag || { cmd: [] };
googletag.cmd.push( function() {
	const mappingHeader = googletag.sizeMapping()
		.addSize(
			[ 1024, 0 ],
			[
				[ 940, 220 ],
				[ 940, 90 ],
				[ 728, 90 ],
			],
		)
		.addSize(
			[ 768, 0 ],
			[
				[ 728, 90 ],
				[ 468, 60 ],
			],
		)
		.addSize(
			[ 0, 0 ],
			[
				[ 320, 100 ],
				[ 320, 50 ],
				[ 300, 50 ],
				[ 1, 1 ],
			],
		)
		.build();

	let headerSlot, sidebarTopSlot, sidebarBottomSlot, mainBodySlot, mappingMainBody, mappingSidebar;

	if ( is_home ) {
		headerSlot = googletag.defineSlot(
			'/23075364728/Homepage_Leader_728x90',
			[
				[ 336, 280 ],
				[ 320, 50 ],
				[ 728, 90 ],
				[ 940, 90 ],
				[ 940, 220 ],
				[ 300, 250 ],
				[ 468, 60 ],
				[ 300, 50 ],
				[ 1, 1 ],
			],
			'div-gpt-ad-1649896-1',
		).addService( googletag.pubads() );

		sidebarTopSlot = googletag.defineSlot(
			'/23075364728/Homepage_300x250',
			[
				[ 300, 600 ],
				[ 300, 250 ],
			],
			'div-gpt-ad-1649896-2',
		).addService( googletag.pubads() );

		sidebarBottomSlot = googletag.defineSlot(
			'/23075364728/Homepage_300x600',
			[
				[ 300, 600 ],
				[ 300, 250 ],
			],
			'div-gpt-ad-1649896-3',
		).addService( googletag.pubads() );

		mappingMainBody = googletag.sizeMapping()
			.addSize(
				[ 1180, 0 ],
				[
					[ 728, 90 ],
					[ 468, 60 ],
				],
			)
			.addSize(
				[ 960, 0 ],
				[
					[ 468, 60 ],
				],
			)
			.addSize(
				[ 820, 0 ],
				[
					[ 728, 90 ],
					[ 468, 60 ],
				],
			)
			.addSize(
				[ 480, 0 ],
				[
					[ 468, 60 ],
					[ 300, 250 ],
					[ 320, 100 ],
				],
			)
			.addSize(
				[ 0, 0 ],
				[
					[ 300, 250 ],
					[ 320, 100 ],
					[ 320, 50 ],
					[ 300, 50 ],
					[ 1, 1 ],
				],
			)
			.build();

		mappingSidebar = googletag.sizeMapping()
			.addSize(
				[ 1024, 0 ],
				[
					[ 300, 600 ],
					[ 300, 250 ],
				],
			)
			.addSize(
				[ 0, 0 ],
				[
					[ 300, 600 ],
					[ 300, 250 ],
					[ 1, 1 ],
				],
			)
			.build();

		mainBodySlot = googletag.defineSlot(
			'/23075364728/Homepage_468x60',
			[
				[ 940, 220 ],
				[ 940, 90 ],
				[ 728, 90 ],
				[ 468, 60 ],
			],
			'div-gpt-ad-1649896-4',
		).addService( googletag.pubads() );
	} else {
		headerSlot = googletag.defineSlot(
			'/23075364728/InnerPages_Leader_728x90',
			[
				[ 468, 60 ],
				[ 1, 1 ],
				[ 940, 220 ],
				[ 300, 50 ],
				[ 320, 50 ],
				[ 336, 280 ],
				[ 728, 90 ],
				[ 940, 90 ],
				[ 300, 250 ],
			],
			'div-gpt-ad-1649896-5',
		).addService( googletag.pubads() );

		sidebarTopSlot = googletag.defineSlot(
			'/23075364728/InnerPages_300x250',
			[
				[ 300, 600 ],
				[ 300, 250 ],
				[ 336, 280 ],
				[ 342, 600 ],
				[ 304, 600 ],
				[ 364, 600 ],
			],
			'div-gpt-ad-1649896-6',
		).addService( googletag.pubads() );

		sidebarBottomSlot = googletag.defineSlot(
			'/23075364728/InnerPages_300x600',
			[
				[ 300, 600 ],
				[ 300, 250 ],
			],
			'div-gpt-ad-1649896-7',
		).addService( googletag.pubads() );

		mappingMainBody = googletag.sizeMapping()
			.addSize(
				[ 1180, 0 ],
				[
					[ 728, 400 ],
					[ 728, 90 ],
					[ 580, 400 ],
					[ 468, 60 ],
				],
			)
			.addSize(
				[ 980, 0 ],
				[
					[ 580, 400 ],
					[ 468, 60 ],
				],
			)
			.addSize(
				[ 960, 0 ],
				[
					[ 468, 60 ],
				],
			)
			.addSize(
				[ 820, 0 ],
				[
					[ 728, 90 ],
					[ 580, 400 ],
					[ 468, 60 ],
				],
			)
			.addSize(
				[ 640, 0 ],
				[
					[ 580, 400 ],
					[ 468, 60 ],
					[ 342, 342 ],
				],
			)
			.addSize(
				[ 480, 0 ],
				[
					[ 468, 60 ],
					[ 342, 342 ],
					[ 300, 250 ],
					[ 320, 100 ],
				],
			)
			.addSize(
				[ 0, 0 ],
				[
					[ 342, 342 ],
					[ 300, 250 ],
					[ 320, 100 ],
					[ 320, 50 ],
					[ 300, 50 ],
					[ 1, 1 ],
				],
			)
			.build();

		mappingSidebar = googletag.sizeMapping()
			.addSize(
				[ 1024, 0 ],
				[
					[ 342, 600 ],
					[ 304, 600 ],
					[ 364, 600 ],
					[ 300, 600 ],
					[ 300, 250 ],
					[ 1, 1 ],
				],
			)
			.addSize(
				[ 0, 0 ],
				[
					[ 342, 600 ],
					[ 304, 600 ],
					[ 364, 600 ],
					[ 300, 600 ],
					[ 300, 250 ],
					[ 1, 1 ],
				],
			)
			.build();

		mainBodySlot = googletag.defineSlot(
			'/23075364728/InnerPages_468x60',
			[
				[ 940, 220 ],
				[ 940, 90 ],
				[ 728, 90 ],
				[ 728, 400 ],
				[ 580, 400 ],
				[ 468, 60 ],
				[ 342, 342 ],
				[ 336, 280 ],
				[ 300, 350 ],
				[ 320, 100 ],
				[ 320, 50 ],
			],
			'div-gpt-ad-1649896-8',
		).addService( googletag.pubads() );
	}

	headerSlot.defineSizeMapping( mappingHeader );
	sidebarTopSlot.defineSizeMapping( mappingSidebar );
	sidebarBottomSlot.defineSizeMapping( mappingSidebar );
	mainBodySlot.defineSizeMapping( mappingMainBody );

	googletag.pubads().enableSingleRequest();
	googletag.pubads().collapseEmptyDivs( true );
	googletag.pubads().enableLazyLoad( { fetchMarginPercent: 50, renderMarginPercent: 50, mobileScaling: 1.7 } );

	googletag.enableServices();

	const ads = document.querySelectorAll( '[id*="div-gpt-ad"]' );
	ads.forEach( function( element ) {
		const style = getComputedStyle( element );
		if ( style.display === 'none' ) {
			if ( element.parentNode.childElementCount === 1 ) {
				element.parentNode.remove();
			} else {
				element.remove();
			}
		} else {
			googletag.cmd.push( function() {
				googletag.display( element.id );
			} );
		}
	} );
} );
